module.exports = __webpack_public_path__ + "img/snake.8f4f926c.png";